export default "__VITE_ASSET__CsY1zM4R__"